module.exports = __webpack_public_path__ + "static/media/Click-Slice-SEO-Certification.f207fe92.png";